import styled from '@emotion/styled';
import { Colors } from '../../core/theme/Colors';

export const NoEntriesInGroupHintLabel = styled.div`
    font-size: 14px;
    color: ${Colors.TextLighter};
`;
